import { LoadState } from "../../../constants/enums";
import { IExternalLeadMasterStatus, IExternalLeadStatus, IExternalLeadStatusState } from "./external-lead-status.types";

export const defaultExternalLeadStatus: IExternalLeadStatus = {
  name: null,
  status: "ACTIVE",
  company_outlet_uuid: "",
  company_outlet_name: "",
  master_external_status_uuid: "",
  actual_flow: null
};

export const defaultExternalLeadMasterStatus: IExternalLeadMasterStatus = {
  master_external_status_uuid: null,
  name: "ONGOING",
  description: "",
  status: "ACTIVE",

};

export const defaultExternalLeadStatusState: IExternalLeadStatusState = {
  outlet_external_status_lifecycle: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  statusList: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  status: {
    data: defaultExternalLeadStatus,
    loading: LoadState.NotLoaded,
    error: null,
  },
  masterStatusList: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  masterStatus: {
    data: defaultExternalLeadMasterStatus,
    loading: LoadState.NotLoaded,
    error: null,
  },
};